//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'article_1',
  data () {
    return {
      msg: ''
    }
  },
  created () {
      window.scrollTo(0,0)
  }
}



// WEBPACK FOOTER //
// ./src/components/article/article_1.vue